<div class="especialidade-container">
    <app-custom-table [data]="especialidades" [metadata]="tableMetadata" [loading]="loading"></app-custom-table>
    @if (loading) {
        <div class="mt-2">Carregando especialidades...</div>
    }
    @if (!loading && erro) {
        <div class="mt-2 text-red-500">{{ erro }}</div>
    }
</div>
